import XLSX from 'xlsx'
import dayjs from 'dayjs'
import { CMS_MODULE_CARDS } from './components/HomeKpiGrid.vue'
import { TOP_RANKING_TABS } from './components/HomeDataTableHub.vue'

/**
 * Download a Blob in browser
 */
function downloadFile(blob, filename) {
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.style.display = 'none'
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  setTimeout(() => {
    document.body.removeChild(a)
    window.URL.revokeObjectURL(url)
  }, 100)
}

/**
 * Format number with thousand separators
 */
function formatNumber(num) {
  if (num === undefined || num === null) return '0'
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}

/**
 * Export Dashboard Data to Excel (.xlsx) with multiple organized worksheets
 */
export function exportDashboardExcel({
  rangeLabel = 'Toàn bộ thời gian',
  kpis = {},
  cmsStats = {},
  pageStats = [],
  qrStats = [],
  topRankings = {}
}) {
  const wb = XLSX.utils.book_new()
  const exportDateStr = dayjs().format('DD/MM/YYYY HH:mm')

  // Sheet 1: Tổng quan KPI & Thống kê Module
  const kpiRows = [
    ['BÁO CÁO TỔNG QUAN CHỈ SỐ DASHBOARD'],
    ['Kỳ báo cáo:', rangeLabel],
    ['Thời gian xuất:', exportDateStr],
    [],
    ['Nhóm chỉ số', 'Tên chỉ số / Module', 'Giá trị', 'Đơn vị', 'Nguồn dữ liệu', 'Ghi chú'],
    [
      'Truy cập & Tương tác số',
      'Người dùng hoạt động',
      kpis.activeToday || 0,
      'người dùng',
      'Google Analytics 4',
      'Người dùng trong kỳ báo cáo'
    ],
    [
      'Truy cập & Tương tác số',
      'Lượt xem trang',
      kpis.totalPageViews || 0,
      'lượt xem',
      'Google Analytics 4',
      'Tổng số lần tải trang web'
    ],
    [
      'Truy cập & Tương tác số',
      'Tổng số tương tác / Sự kiện',
      kpis.totalVisits || 0,
      'sự kiện',
      'Google Analytics 4',
      'Tổng lượt tương tác'
    ],
    [
      'Truy cập & Tương tác số',
      'Lượt quét mã QR',
      kpis.totalQrScans || 0,
      'lượt quét',
      'Google Analytics 4',
      'Quét QR tại điểm du lịch & dịch vụ'
    ],
    [
      'Truy cập & Tương tác số',
      'Lượt tra cứu tìm kiếm',
      kpis.totalSearches || 0,
      'lượt tìm',
      'Google Analytics 4',
      'Tra cứu trên website'
    ]
  ]

  CMS_MODULE_CARDS.forEach((mod) => {
    const stat = (cmsStats && cmsStats[mod.key]) || {}
    kpiRows.push([
      'Thống kê dữ liệu CSDL',
      mod.title,
      stat.total || 0,
      mod.unit,
      'Cơ sở dữ liệu',
      `Yêu thích: ${stat.likes || 0} | Đánh giá: ${stat.rating || '5.0'}`
    ])
  })

  const wsKpis = XLSX.utils.aoa_to_sheet(kpiRows)
  wsKpis['!cols'] = [
    { wch: 25 },
    { wch: 30 },
    { wch: 15 },
    { wch: 15 },
    { wch: 20 },
    { wch: 35 }
  ]
  XLSX.utils.book_append_sheet(wb, wsKpis, 'Tong_Quan_KPI')

  // Sheet 2: Top Trang Xem Nhiều
  const pageRows = [
    ['DANH SÁCH TRANG CÓ LƯỢT XEM CAO NHẤT (GA4)'],
    ['Kỳ báo cáo:', rangeLabel],
    [],
    ['STT', 'Tiêu đề / Đường dẫn trang', 'Lượt xem (Views)', 'Tỷ trọng (%)']
  ]
  if (pageStats && pageStats.length > 0) {
    pageStats.forEach((p, idx) => {
      pageRows.push([idx + 1, p.title || p.path, p.views || 0, `${p.percentage || 0}%`])
    })
  } else {
    pageRows.push(['', 'Chưa có dữ liệu', 0, '0%'])
  }
  const wsPages = XLSX.utils.aoa_to_sheet(pageRows)
  wsPages['!cols'] = [{ wch: 8 }, { wch: 50 }, { wch: 18 }, { wch: 15 }]
  XLSX.utils.book_append_sheet(wb, wsPages, 'Top_Trang_Xem_Nhieu')

  // Sheet 3: Hiệu Quả Quét Mã QR
  const qrRows = [
    ['THỐNG KÊ LƯỢT QUÉT MÃ QR TẠI ĐIỂM DU LỊCH (GA4)'],
    ['Kỳ báo cáo:', rangeLabel],
    [],
    ['STT', 'Điểm quét QR / Đường dẫn', 'Lượt quét (Scans)', 'Tỷ trọng (%)']
  ]
  if (qrStats && qrStats.length > 0) {
    qrStats.forEach((q, idx) => {
      qrRows.push([idx + 1, q.title || q.path, q.scans || 0, `${q.percentage || 0}%`])
    })
  } else {
    qrRows.push(['', 'Chưa có dữ liệu quét mã QR', 0, '0%'])
  }
  const wsQr = XLSX.utils.aoa_to_sheet(qrRows)
  wsQr['!cols'] = [{ wch: 8 }, { wch: 50 }, { wch: 18 }, { wch: 15 }]
  XLSX.utils.book_append_sheet(wb, wsQr, 'Hieu_Qua_Quet_QR')

  // Sheet 4: Top 5 Bài Nổi Bật (7 Modules)
  const rankingRows = [
    ['DANH SÁCH TOP 5 BÀI NỔI BẬT THEO CHUYÊN MỤC (CSDL)'],
    ['Kỳ báo cáo:', rangeLabel],
    [],
    ['Chuyên mục', 'Hạng', 'Tên bài / Địa điểm', 'Danh mục', 'Địa điểm', 'Đánh giá', 'Lượt xem']
  ]

  TOP_RANKING_TABS.forEach((tab) => {
    const items = (topRankings && topRankings[tab.key]) || []
    if (items.length > 0) {
      items.forEach((item, idx) => {
        rankingRows.push([
          tab.label,
          idx + 1,
          item.name || item.title || '---',
          item.type || tab.defaultType,
          item.location || 'Thủ Dầu Một',
          item.rating || '5.0',
          item.view_count || 0
        ])
      })
    } else {
      rankingRows.push([tab.label, '-', 'Chưa có dữ liệu', tab.defaultType, '-', '-', 0])
    }
  })

  const wsRankings = XLSX.utils.aoa_to_sheet(rankingRows)
  wsRankings['!cols'] = [
    { wch: 26 },
    { wch: 8 },
    { wch: 42 },
    { wch: 24 },
    { wch: 28 },
    { wch: 12 },
    { wch: 15 }
  ]
  XLSX.utils.book_append_sheet(wb, wsRankings, 'Top_5_Bai_Noi_Bat')

  // Save workbook
  const filename = `Bao_Cao_Tong_Quan_Dashboard_${dayjs().format('YYYYMMDD_HHmm')}.xlsx`
  XLSX.writeFile(wb, filename)
}

/**
 * Export Dashboard Data to CSV (.csv) with UTF-8 BOM
 */
export function exportDashboardCsv({
  rangeLabel = 'Toàn bộ thời gian',
  kpis = {},
  cmsStats = {},
  pageStats = [],
  qrStats = [],
  topRankings = {}
}) {
  const exportDateStr = dayjs().format('DD/MM/YYYY HH:mm')
  const lines = []

  const escapeCsv = (val) => {
    if (val === undefined || val === null) return '""'
    const str = String(val).replace(/"/g, '""')
    return `"${str}"`
  }

  // Header
  lines.push(escapeCsv('BÁO CÁO TỔNG QUAN HỆ THỐNG & PHÂN TÍCH TRUY CẬP'))
  lines.push(`${escapeCsv('Kỳ báo cáo:')},${escapeCsv(rangeLabel)}`)
  lines.push(`${escapeCsv('Thời gian xuất:')},${escapeCsv(exportDateStr)}`)
  lines.push('')

  // Section 1: KPI
  lines.push(escapeCsv('--- 1. CÁC CHỈ SỐ KPI & THỐNG KÊ MODULE ---'))
  lines.push(
    [
      escapeCsv('Nhóm chỉ số'),
      escapeCsv('Tên chỉ số / Module'),
      escapeCsv('Giá trị'),
      escapeCsv('Đơn vị'),
      escapeCsv('Nguồn dữ liệu')
    ].join(',')
  )

  const kpiData = [
    [
      'Truy cập & Tương tác',
      'Người dùng hoạt động',
      formatNumber(kpis.activeToday || 0),
      'người dùng',
      'GA4'
    ],
    [
      'Truy cập & Tương tác',
      'Lượt xem trang',
      formatNumber(kpis.totalPageViews || 0),
      'lượt xem',
      'GA4'
    ],
    [
      'Truy cập & Tương tác',
      'Tổng số tương tác',
      formatNumber(kpis.totalVisits || 0),
      'sự kiện',
      'GA4'
    ],
    [
      'Truy cập & Tương tác',
      'Lượt quét mã QR',
      formatNumber(kpis.totalQrScans || 0),
      'lượt quét',
      'GA4'
    ],
    [
      'Truy cập & Tương tác',
      'Lượt tìm kiếm',
      formatNumber(kpis.totalSearches || 0),
      'lượt tìm',
      'GA4'
    ]
  ]

  CMS_MODULE_CARDS.forEach((mod) => {
    const stat = (cmsStats && cmsStats[mod.key]) || {}
    kpiData.push([
      'Thống kê dữ liệu CSDL',
      mod.title,
      formatNumber(stat.total || 0),
      mod.unit,
      'CSDL'
    ])
  })

  kpiData.forEach((row) => {
    lines.push(row.map(escapeCsv).join(','))
  })

  lines.push('')
  lines.push(escapeCsv('--- 2. TOP TRANG XEM NHIỀU NHẤT (GA4) ---'))
  lines.push(
    [
      escapeCsv('STT'),
      escapeCsv('Đường dẫn / Tiêu đề'),
      escapeCsv('Lượt xem'),
      escapeCsv('Tỷ lệ (%)')
    ].join(',')
  )
  if (pageStats && pageStats.length > 0) {
    pageStats.forEach((p, idx) => {
      lines.push(
        [
          escapeCsv(idx + 1),
          escapeCsv(p.title || p.path),
          escapeCsv(p.views || 0),
          escapeCsv(`${p.percentage || 0}%`)
        ].join(',')
      )
    })
  }

  lines.push('')
  lines.push(escapeCsv('--- 3. THỐNG KÊ QUÉT MÃ QR (GA4) ---'))
  lines.push(
    [
      escapeCsv('STT'),
      escapeCsv('Địa điểm du lịch / Đường dẫn'),
      escapeCsv('Lượt quét'),
      escapeCsv('Tỷ lệ (%)')
    ].join(',')
  )
  if (qrStats && qrStats.length > 0) {
    qrStats.forEach((q, idx) => {
      lines.push(
        [
          escapeCsv(idx + 1),
          escapeCsv(q.title || q.path),
          escapeCsv(q.scans || 0),
          escapeCsv(`${q.percentage || 0}%`)
        ].join(',')
      )
    })
  }

  lines.push('')
  lines.push(escapeCsv('--- 4. TOP 5 BÀI NỔI BẬT THEO CHUYÊN MỤC (CSDL) ---'))
  lines.push(
    [
      escapeCsv('Chuyên mục'),
      escapeCsv('Hạng'),
      escapeCsv('Tên bài / Địa điểm'),
      escapeCsv('Danh mục'),
      escapeCsv('Lượt xem')
    ].join(',')
  )
  TOP_RANKING_TABS.forEach((tab) => {
    const items = (topRankings && topRankings[tab.key]) || []
    items.forEach((item, idx) => {
      lines.push(
        [
          escapeCsv(tab.label),
          escapeCsv(idx + 1),
          escapeCsv(item.name || item.title || '---'),
          escapeCsv(item.type || tab.defaultType),
          escapeCsv(item.view_count || 0)
        ].join(',')
      )
    })
  })

  // Prepend UTF-8 BOM (\uFEFF)
  const csvContent = '\uFEFF' + lines.join('\r\n')
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
  const filename = `Bao_Cao_Tong_Quan_Dashboard_${dayjs().format('YYYYMMDD_HHmm')}.csv`
  downloadFile(blob, filename)
}
